import React from "react";

export default function Logo({ size = 32, withWord = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/logo-g.png"
        alt="Getaride"
        style={{ width: size, height: size }}
        className="rounded-lg object-contain"
      />
      {withWord && (
        <span
          className="font-extrabold tracking-tight text-foreground"
          style={{ fontSize: size * 0.52 }}
        >
          Getaride
        </span>
      )}
    </div>
  );
}
